export const defaultPaymentLinksActionData: PaymentLinksActionData = {
  payment_link: {
    amount_symbol: "",
    description: "",
    id: "",
    is_live: false,
    name: "",
    items: [],
    quantity_type: "FIXED",
    totals: {
      subtotal: 0,
      total: 0,
      taxes: 0,
    },
  },
};

export const defaultBrandSettings: BrandSettings = {
  brand_primary_color: "#23395B",
  brand_accent_color: "#FFE3C3",
  icon: "",
  privacy_policy: "",
  terms_of_service: "",
};

export const defaultPaymentIntentData: PaymentIntent = {
  show_steps: false,
  show_countdown_timer: false,
  hide_header: false,
  hide_amount_sidebar: false,
  payment_methods: [],
  form_only: false,
  amount: "0",
  subtotal_amount: "0",
  amount_currency: "0",
  formatted_amount: 0,
  id: "--",
  is_live: false,
  secret: "",
  status: "UNPROCESSED",
  hide_retry_button: false,
  hide_try_different_method_button: false,
  expiration_date: null,
  hide_navigation_to_payment_methods: false,
  account: "--",
  organization: 0,
  tracking_id: null,
  country: null,
  fees: null,
  total_discounts: null,
};
